exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#reChargeExplain {\n  font-size: 0.15rem;\n  padding: 0.07rem 0.13rem 0.25rem 0.13rem;\n  color: #1E283C;\n}\n#reChargeExplain .header {\n  margin-bottom: 0.15rem;\n}\n#reChargeExplain h3 {\n  font-size: 0.14rem;\n  line-height: 1.7;\n  padding: 0.05rem 0;\n}\n#reChargeExplain p {\n  line-height: 1.7;\n}\n#reChargeExplain section {\n  margin-bottom: 0.12rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/rechargeExplain/index.less
// module id = 289
// module chunks = 0